import { NotificationsEventBusEmiter } from './eventBus'
import { NotificationsCore } from './notificationsCore'
import getStoreModule from './store'

export const NotificationsModule = {
  config(Vue, { store }) {
    let EventBus = new Vue()
    Vue.$notificationsEventEmiter = new NotificationsEventBusEmiter(EventBus)

    let storeModule = getStoreModule(Vue)
    store.registerModule('notifications', storeModule)

    const systemNotificationOptions = store.getters.appModel.Settings.NotificationOptions
    const userNotificationOptions = store.getters.appModel.UserModel?.Settings?.NotificationOptions
    const notificationOptions = this.getNotificationOptions(systemNotificationOptions, userNotificationOptions)

    Vue.$notificationsCore = Vue.prototype.$notificationsCore = new NotificationsCore(store, EventBus, notificationOptions?.enabled, notificationOptions?.types)
  },
  getNotificationOptions(systemNotificationOptions, userNotificationOptions) {
    return userNotificationOptions ?? systemNotificationOptions
  }
}

